import { FormEvent, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../../../store/slices/authSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { RouteNames } from "../../../navigation/RouteNames";
import { useTranslation } from "../../../translations/i18n";

export const useResetPasswordScreen = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const { loading, error, fieldErrors } = useAppSelector((state) => state.auth);

  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);
  const emailFromUrl = useMemo(
    () => searchParams.get("email") || "",
    [searchParams],
  );

  const [email, setEmail] = useState(emailFromUrl);
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const hasValidLink = Boolean(token && emailFromUrl);

  const handleSubmit = async (event?: FormEvent) => {
    event?.preventDefault();
    setSuccessMessage("");

    if (!hasValidLink) {
      return;
    }

    const result = await dispatch(
      resetPassword({
        token,
        email,
        password,
        password_confirmation: passwordConfirmation,
      }),
    );

    if (resetPassword.fulfilled.match(result)) {
      setSuccessMessage(result.payload);
      setPassword("");
      setPasswordConfirmation("");
    }
  };

  const getFieldError = (field: string) => {
    return fieldErrors[field]?.[0] || "";
  };

  return {
    email,
    password,
    passwordConfirmation,

    setEmail,
    setPassword,
    setPasswordConfirmation,

    loading,
    error: error || "",
    successMessage,
    hasValidLink,
    getFieldError,

    handleSubmit,
    goToLogin: () => navigate(RouteNames.login, { replace: true }),

    t,
  };
};
